import { useState, useEffect } from "react";
import { observer } from "mobx-react";
import { CloseSquare } from "iconsax-react";
import { Dialog, DialogContent, DialogTitle, DialogActions, IconButton, Typography, RadioGroup, FormControlLabel, Radio, TextField, Box, Collapse } from "@mui/material";
import { LoadingButton } from "@mui/lab";
import SaveIcon from '../../icons/save-icon.png';
import { TimePicker } from '@mui/x-date-pickers/TimePicker';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import dayjs from "dayjs";

const AvailabilityModal = observer(({ uiStore, show, setShow, availability, setAvailability }) => {
    const [loading, setLoading] = useState(false);
    const [times, setTimes] = useState({
        status: 'closed',
        Sunday: {
            from: dayjs(new Date()),
            to: dayjs(new Date()),
        },
        Monday: {
            from: dayjs(new Date()),
            to: dayjs(new Date()),
        },
        Tuesday: {
            from: dayjs(new Date()),
            to: dayjs(new Date()),
        },
        Wednesday: {
            from: dayjs(new Date()),
            to: dayjs(new Date()),
        },
        Thursday: {
            from: dayjs(new Date()),
            to: dayjs(new Date()),
        },
        Friday: {
            from: dayjs(new Date()),
            to: dayjs(new Date()),
        },
        Saturday: {
            from: dayjs(new Date()),
            to: dayjs(new Date()),
        },
    });

    const days = ['Saturday', 'Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday']

    const handleChange = (value, day, part) => {
        const data = { ...times };

        if (!data[day])
            data[day] = {};

        data[day][part] = value;

        setTimes(data);
    }

    const handleStatusChange = (e, status) => {
        const data = { ...times };
        data.status = status;
        setTimes(data);
    }

    const save = async () => {
        setLoading(true);
        const res = await uiStore.addAvailability(times, times._id);
        const result = times._id ? { ...times } : { ...times, _id: res.data?._id }
        setAvailability(result);
        setLoading(false);
        setShow(false);
    }

    useEffect(() => {
        if (availability)
            setTimes(availability);

    }, [availability]);

    return (

        <Dialog open={show} onClose={() => setShow(false)}
            PaperProps={{ sx: { padding: '20px', maxWidth: '450px', width: '100%' }, variant: 'round' }}
        >
            <DialogTitle>
                Select Availability Days
                <IconButton
                    aria-label="close"
                    onClick={() => setShow(false)}
                    sx={{
                        position: 'absolute',
                        right: 8,
                        top: 8,
                    }}
                >
                    <CloseSquare
                        size="30"
                        variant="Bulk"
                    />
                </IconButton>
            </DialogTitle>
            <DialogContent>
                <Typography >Select time</Typography>
                <RadioGroup
                    defaultValue="closed"
                    onChange={handleStatusChange}
                    value={times.status}
                >
                    <FormControlLabel value="closed" control={<Radio />} label="Not available | Closed" />
                    <FormControlLabel value="open" control={<Radio />} label="Available All day | Open 24 hrs" />
                    <FormControlLabel value="custom" control={<Radio />} label="Custom Hours" />
                    <Typography fontSize={12} sx={{ ml: 4, color: '#888' }}>Opens at specific hours or days</Typography>
                </RadioGroup>


                <Collapse in={times.status === 'custom'}>
                    <Box sx={{ mt: 3 }}>
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                            {days.map(day =>
                                <Box key={day} sx={{ display: "flex", mt: 2, mb: 2 }}>
                                    <Typography sx={{ width: '100px', mt: 2 }}>{day}</Typography>
                                    <TimePicker
                                        onChange={(v) => handleChange(v, day, 'from')}
                                        value={times?.[day]?.from}
                                        label="From"
                                        renderInput={(params) => <TextField sx={{ width: '40%', mr: 1 }} {...params} />}
                                    />
                                    <TimePicker
                                        onChange={(v) => handleChange(v, day, 'to')}
                                        value={times?.[day]?.to}
                                        label="To"
                                        renderInput={(params) => <TextField sx={{ width: '40%' }} {...params} />}
                                    />
                                </Box>
                            )}
                        </LocalizationProvider>
                    </Box>
                </Collapse>

            </DialogContent>
            <DialogActions>
                <LoadingButton loading={!!loading} onClick={save} variant="contained" color="secondary"
                    endIcon={
                        <img src={SaveIcon}
                            alt='Save icon'
                            width={24}
                        />
                    }
                >
                    Save
                </LoadingButton>
            </DialogActions>
        </Dialog >
    );
});

export default AvailabilityModal;
